import { useMemo } from "react";

import { Grid } from "@mui/material";
import { DisplayPropertiesCardArray } from "@covertree/ui/content";
import { PolicyDetailsContentProps } from "../../../types";

export function Discounts({ policy, loading }: PolicyDetailsContentProps) {
  const discountsItems = useMemo(
    () =>
      policy?.units[0]?.pricing?.commissions
        ?.filter(
          ({ recipient }) =>
            !recipient.includes("Commission") && !recipient.includes("Tax")
        )
        .map(({ amount, recipient }) => ({
          itemLabel: recipient,
          itemValue: amount,
          itemPrefix: "$",
        })),
    [policy?.units[0]?.pricing?.commissions]
  );
  return (
    <Grid item xs={12}>
      <DisplayPropertiesCardArray
        sectionLabel="Discounts"
        loading={!policy && loading}
        value={discountsItems?.length ? discountsItems : "No discounts"}
      />
    </Grid>
  );
}
